<template>
  <ChartBase
    title="Weekly Sales (Last 90 Days)"
    :subtitle="totalSalesUSD || '-'"
    :loading="loading"
  >
    <LineChart
      class="chart-ninety-day-sales line-chart"
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
  </ChartBase>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { LineChartOptions } from '@/constants/ChartOptions'
import ChartBase from '@/components/ChartBase.vue'

import _min from 'lodash/min'
import _max from 'lodash/max'
import _sum from 'lodash/sum'

import { Line as LineChart } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)
export default {
  name: 'ChartNinetyDaySales',
  components: {
    ChartBase,
    LineChart,
  },
  data() {
    return {
      loading: true,
      totalSalesUSD: null,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: LineChartOptions,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
  },
  async mounted() {
    const { data: chartData } = await this.getChartNinetyDaySales()
    this.chartData.labels = chartData.labels
    this.chartData.datasets = chartData.datasets
    await this.setChartStepSize(chartData.datasets[0].data)
    await this.setTotalSales(chartData.datasets[0].data)
    this.loading = false
  },
  methods: {
    ...mapActions('shop', ['getChartNinetyDaySales']),

    setChartStepSize(chartDataSet) {
      let min = _min(chartDataSet)
      let headroom = 1.15
      let max = _max(chartDataSet) * headroom

      this.chartOptions.scales.y.suggestedMax = max
      let approxStepSize = (max - min) / 3
      let roundToNearest = 20
      this.chartOptions.scales.y.ticks.stepSize =
        Math.ceil(approxStepSize / roundToNearest) * roundToNearest
    }, // setChartStepSize
    setTotalSales(chartDataSet) {
      let sum = _sum(chartDataSet)
      this.totalSalesUSD = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(sum)
    }, // setTotalSales
  },
}
</script>

<style scoped>
.line-chart {
  height: 200px;
}
</style>
